<template>

    <div class="navbar-container">

        <nav class="navbar fixed-top mx-auto" :class="classList">

            <div class="d-flex w-100">

                <div class="mr-auto">
                    <!-- Left -->
                    <a v-if="typeof(left) === 'object'" @click="doAction(leftItem.action)"><img class="pl-4" :src="leftItem.icon"></a>

                    <!-- Center title -->
                    <span class="navbar-brand text-truncate py-0 mr-0" :class="{ wider: !right }">{{ title? title : '' }}</span>
                </div>

                <!-- todo: use left format -->
                <!-- Right -->
                <div v-for="(item, key) in rightItems" :key="key" class="mr-4">
                    <a v-if="item == 'search'" @click="$root.openModal('modal_search')"><img src="/images/icon-browse-search.svg"></a>
                    <a v-else-if="item == 'close'" @click="$root.goBackTo()"><img src="/images/icon-cancel.svg"></a>
                    <a v-else-if="item == 'close-mpl'" @click="close"><img src="/images/icon-cancel.svg"></a>
                    <a v-else-if="item == 'close-dark'" @click="$root.goBackTo()"><img src="/images/icon-close.svg"></a>
                </div>

            </div>

        </nav>

    </div>

</template>

<script>
    export default {
        props: ["left", "title", "right", "classList"],

        computed: {
            leftItem() {
                return {
                    action: this.left.action,
                    icon: "/images/" + this.left.icon + ".svg"
                }
            },

            rightItems() {
                let allItems = []

                if(Array.isArray(this.right)) {
                    allItems = this.right
                } else if(typeof this.right === 'string') {
                    allItems.push(this.right)
                }

                return allItems
            },
        },

        methods: {
            doAction(action) {
                let firstArg = typeof action.args === 'object'? action.args[0] : null
                this[action.name](firstArg)
            },

            close() {
                let exitLoc = this.$root.getExitLocation()

                // if mobile
                window.location.replace(exitLoc)
            },

            back(to) {
                this.$root.goBackTo(to)
            },

            forward(to) {
                this.$root.goForwardTo(to)
            }
        }
    }
</script>

<style scoped>
    .navbar-container{
        height: 3.5rem;
        min-height: 3.5rem !important;
    }
    .navbar {
        z-index: 1035 !important;
        max-width: 576px;
        height: inherit;
        right: 0;
        left: 0;
        background-color: inherit;
        color: inherit;
    }
    .navbar-shadow {
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    }
    .wider {
        width: 16.25rem;
    }
</style>
